import { setLocale } from "yup";

export const yupConfig = () =>
  setLocale({
    mixed: {
      default: "invalid",
      required: "blank"
    },
    string: {
      max: ({ max }: { max: number }) => ({
        key: "tooLong",
        values: { count: max }
      }),
      min: ({ min }: { min: number }) => ({
        key: "tooShort",
        values: { count: min }
      }),
      matches: "invalid",
      email: "invalidEmail",
      length: ({ length }: { length: number }) => ({
        key: "wrongLength",
        values: { count: length }
      })
    },
    array: {
      max: ({ max }: { max: number }) => ({
        key: "maxAnswers",
        values: { count: max }
      })
    }
  });
